import React from 'react';

const Logo = ({ size = 50 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
      }}
    >
      <rect width="32" height="32" rx="8" fill="url(#gradient)"/>
      <text 
        x="16" 
        y="16" 
        dominant-baseline="middle"
        textAnchor="middle" 
        fill="white" 
        fontFamily="Arial, sans-serif" 
        fontSize="18" 
        fontWeight="bold"
      >
        启
      </text>
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{stopColor:'#1890ff', stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'#722ed1', stopOpacity:1}} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;